import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/images/logo.png";
import HeaderBackground from "../../assets/images/headerBackground.png";
import HeaderBackground2 from "../../assets/images/headerBackground2.jpeg";
import { useAuth } from "../../utils/AuthContext";
import axios from "axios";
import { AUTH_URL } from "../../utils/constants";
import { toSentenceCase } from "../../utils/utils";

const Header = () => {
  const navigate = useNavigate();
  const { user, isAuthenticated, logout } = useAuth();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const dropdownRef = useRef(null);
  const notificationRef = useRef(null);

  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };
  const notificationsDropdown = () => {
    setNotificationsOpen((prev) => !prev);
  };
  useEffect(() => {
    if (!isAuthenticated) return;
    let endpoint = "";
    if (user?.role === "officer") {
      endpoint = `api/officer_receives_notification?officer_name=${encodeURIComponent(user.category)}`;
    } else if (user?.role === "admin") {
      endpoint = `api/admin_receives_notification`;
    } else {
      endpoint = `api/user_notification_status?user_id=${user.userId}`;
    }
    const getNotifiaction = async () => {
      try {
        const res = await axios.get(
          `${AUTH_URL}${endpoint}`,
          // const res = await axios.get(`${AUTH_URL}api/notification_status?user_id=684fbdddf3ecd75c15dd295c`,
          {
            headers: { "Content-Type": "application/json" },
          },
        );
        setNotifications(res.data?.Final_notification_message);
      } catch (error) {
        console.log("No records");
      }
    };
    getNotifiaction();
  }, []);
  const handleLogout = () => {
    logout();
    navigate("/");
  };

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setNotificationsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      className="w-full h-[60px] sm:h-[80px] md:h-[100px] lg:h-[15vh] shadow-[0px_4px_4px_rgba(0,0,0,0.25)] relative "
      style={{
        backgroundImage: `url(${HeaderBackground2})`,
        backgroundSize: "100% 100%",
      }}
    >
      <div className="flex justify-between px-3 sm:px-6 py-1 sm:py-2 items-center h-full">
        {/* Logo and title */}
        <div
          className="flex flex-col items-center justify-center bg-white cursor-pointer rounded-full border-2 border-[#FF6900] h-12 w-12 sm:h-12 sm:w-12 md:h-16 md:w-16 lg:h-[14vh] lg:w-[14vh] lg:ml-4 shrink-0 overflow-hidden"
          onClick={() => navigate("/")}
        >
          <img
            alt="bharat_logo"
            src={Logo}
            className="h-[60%] md:h-[42%] lg:h-[42%] w-[60%] md:w-[42%] lg:w-[42%] object-contain mix-blend-multiply"
          />
          <div className="hidden md:flex flex-col items-center justify-center text-[4px] lg:text-[4.5px] leading-tight font-serif text-center font-medium px-2 w-full mt-[1px]">
            <h1 className="font-semibold whitespace-nowrap">SUPREME AUDIT</h1>
            <h1 className="font-semibold whitespace-nowrap">
              INSTITUTION OF INDIA
            </h1>
            <h1 className="font-medium whitespace-nowrap py-[2px] lg:py-[3px] text-[5px] lg:text-[5.5px]">
              लोकहितार्थ सत्यनिष्ठा
            </h1>
            <h1 className="font-medium whitespace-nowrap">
              Dedicated to Truth in Public
            </h1>
            <h1 className="font-medium whitespace-nowrap">Interest</h1>
          </div>
        </div>

        <div className="absolute left-1/2 transform -translate-x-1/2 w-[55%] sm:w-auto z-0">
          <h1 className="font-semibold text-[13px] leading-[1.2] sm:leading-normal sm:text-base md:text-xl lg:text-3xl text-[#1C398E] text-center font-poppins sm:whitespace-nowrap">
            Comptroller and Auditor <br className="sm:hidden" /> General of
            India
          </h1>
        </div>

        {/* Auth Section */}
        <div className="flex gap-2 sm:gap-4 items-center mt-0 sm:mt-2 mr-1 sm:mr-2">
          {isAuthenticated ? (
            // <>
            //   <span className="text-white font-medium">
            //     Welcome, {user?.name || "User"}
            //   </span>
            //   <button
            //     onClick={handleLogout}
            //     className="px-4 py-2 rounded-full bg-white text-[#D37929] font-semibold hover:bg-[#ffe4cf] transition duration-300 shadow"
            //   >
            //     Logout
            //   </button>
            // </>

            <div
              className="py-3 px-2 sm:p-3 sm:pl-12 gap-0 sm:gap-2 flex items-center"
              style={{
                backgroundImage: `url(${isAuthenticated ? HeaderBackground : ""})`,
                backgroundSize: "100% 100%",
              }}
            >
              <div className="relative " ref={notificationRef}>
                {(user.role === "user" ||
                  user.role === "officer" ||
                  user.role === "admin") && (
                  <button
                    onClick={notificationsDropdown}
                    className="flex items-center gap-2 px-2 py-1 rounded-full  text-[#D37929] font-semibold  hover:bg-[#ffe4cf] transition duration-300"
                  >
                    🔔
                    {notifications.length > 0 && (
                      <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] px-1 flex items-center justify-center">
                        {notifications.length}
                      </span>
                    )}
                  </button>
                )}

                {notificationsOpen && (
                  <div className="absolute -right-10 sm:right-0 mt-2 w-72 sm:w-96 bg-white shadow-lg rounded-lg max-h-96 overflow-y-auto z-50 border">
                    {notifications.length === 0 ? (
                      <p className="p-4 text-center text-gray-500">
                        No notifications
                      </p>
                    ) : (
                      notifications.map((item) => (
                        <div
                          key={item._id}
                          className={`p-4 border-b hover:bg-gray-50 transition ${
                            !item.is_read ? "bg-blue-50" : "bg-white"
                          }`}
                        >
                          <h4 className="font-semibold text-sm">
                            {item.title}
                          </h4>

                          <p className="text-sm text-gray-600 mt-1">
                            {item.message}
                          </p>

                          <p className="text-xs text-gray-400 mt-2">
                            {new Date(item.created_at).toLocaleString()}
                          </p>
                        </div>
                      ))
                    )}
                  </div>
                )}
              </div>
              <div className="relative" ref={dropdownRef}>
                <button
                  onClick={toggleDropdown}
                  className="flex items-center gap-2 px-2 py-1 rounded-full  text-[#0041C0] font-semibold  hover:bg-[#ffe4cf] transition duration-300"
                >
                  <div className="w-8 h-8 bg-[#0041C0] text-white rounded-full flex items-center justify-center font-bold uppercase">
                    {user?.role === "admin"
                      ? "C"
                      : user?.name?.[0]?.toUpperCase() || "U"}
                  </div>
                  <span className="hidden sm:inline">
                    {user?.role === "admin"
                      ? "CAG"
                      : toSentenceCase(user?.name) || "User"}
                  </span>
                  <svg
                    className={`w-4 h-4 transform transition-transform duration-200 ${
                      dropdownOpen ? "rotate-180" : ""
                    }`}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path d="M5.516 7.548L10 12.032l4.484-4.484L16 9.064 10 15.064 4 9.064z" />
                  </svg>
                </button>

                {dropdownOpen && (
                  <div className="absolute right-0 mt-2 w-56 bg-white rounded-md shadow-lg z-50">
                    <div className="px-4 py-3 border-b">
                      <p className="text-sm text-gray-600">Signed in as</p>
                      <p className="text-sm font-semibold text-gray-900">
                        {user?.email || "user@example.com"}
                      </p>
                      <p className="text-xs text-gray-500">
                        Role: {user?.role || "user"}
                      </p>
                    </div>

                    <button
                      onClick={() => {
                        setDropdownOpen(false);
                        navigate("/settings");
                      }}
                      className="w-full text-left px-4 py-2 text-sm hover:bg-gray-100 text-gray-700"
                    >
                      ⚙️ Settings
                    </button>

                    <button
                      onClick={handleLogout}
                      className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 font-semibold"
                    >
                      🚪 Logout
                    </button>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <>
              {/* <button
                onClick={() => navigate("/login")}
                className="px-4 py-2 rounded-full bg-white text-[#D37929] font-semibold hover:bg-[#ffe4cf] transition duration-300 shadow"
              >
                Sign In
              </button>
              <button
                onClick={() => navigate("/register")}
                className="px-4 py-2 rounded-full border border-white text-white font-semibold hover:bg-white hover:text-[#D37929] transition duration-300 shadow"
              >
                Sign Up
              </button> */}
            </>
          )}
        </div>
      </div>
      {/* <hr className="h-px bg-gray-300 border-0" /> */}
    </div>
  );
};

export default Header;
